import { Action, AnyAction } from "@reduxjs/toolkit";

export interface CounterState {
  value: number;
}
export enum SentinelLoadingStatus {
  STARTED = "STARTED",
  LOADING = "LOADING",
  FINISHED = "FINISHED",
  REJECTED = "REJECTED",
}

export interface SentinelEvent<T> {
  status: SentinelLoadingStatus;
  payload: T;
}

export interface OnboardedTeam {
  requesterId: string;
  teamEmail: string;
  teamId: string;
  teamName: string;
}

export interface OnboardedTeamResponse {
  payload: {
    payload: {
      onboardedTeams: OnboardedTeam[];
    };
  }
}

export interface TeamPackage {
  bindleId: string;
  packageName: string;
  teamName: string;
}

export interface TeamPackageListResponse {
  payload: {
    payload: {
      teamPackageList: TeamPackage[];
      };
  }
}
export interface PackageDependency {
  version: string;
  packageName: string;
  dependencyName: string;
  vendorGuidanceStatus: string;
  recommendedVersion: string;
  riskStatus: string;
}

export interface PackageDependencyListResponse {
  payload: {
    payload: {
      packageDependencyList: PackageDependency[];
      };
  }
}

export function createEvent<T>(payload: T): SentinelEvent<T> {
  return {
    status: SentinelLoadingStatus.STARTED,
    payload: payload,
  };
}

export interface DependencyUpgradeRecommendation {
  dependencyName: string;
  currentVersion: string;
  currentVersionStatus: string;
  upgradableVersion: string;
  upgradeRecommendation: string;
}

export interface DryRunResult {
  requestId: string;
  packageName: string;
  latestRelease: string;
  status: string;
  totalRecommendations: number;
  dependencyUpgradeRecommendations: DependencyUpgradeRecommendation[];
  errorMessage?: string;
}

export interface ApiError extends Action {
  message: string;
  error: Error;
}
export function isApiError(action: AnyAction): action is ApiError {
  return action.type.endsWith("rejected");
}